import { render, staticRenderFns } from "./ContactsFailed.vue?vue&type=template&id=74ba641e"
import script from "./ContactsFailed.vue?vue&type=script&lang=js"
export * from "./ContactsFailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports